export const zh_CHS = {
    static: {
        approvalLogs: {
            title: '审批记录',
            approvalOpinion: '审批意见',
            startTime: '接收时间',
            endTime: '处理时间',
            todo: '待办理',
            done: '已办理',
            toAssign: '未指派'
        },
        flowchart: {
            title: '查看流程',
            processNotFound: '流程实例ID为空',
            dataIdIsNull: '单据内码为空',
            flowChart: '流程图',
            complete: '显示设计路线',
            simulation: '显示预测路线',
            sequenceColor: '分支线颜色说明',
            completed: '已运行',
            calculate: '计算路线',
            default: '默认',
            suspend: '计算中断',
            noProcess: '未找到符合条件的流程定义！',
            list: '流程列表',
            noDataId: '单据内码为空',
            noBizDefKey: '流程分类ID为空'
        }
    }
};
